@import (reference) '../../../../constants/spacing.module.less';

.switch-button {
  flex-shrink: 0;
}

.learn-more-button {
  flex-shrink: 0;
}

.external-link {
  font-size: 14px;
  line-height: @space-24;
  margin-left: @space-12;
  display: flex;
  align-items: center;
}

.external-link-icon {
  width: 12px;
  margin-left: @space-4;
}
